import React from "react";

const InformationComponent = () => {
  return (
      <div className="informationContainer">
        <h1>+43 2236 39 70 80</h1>
        <h1>office@mobile-buehne.at</h1>
      </div>
  );
};

export default InformationComponent;
